// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--nV4eL","horizontal-margin":"a10a3f92e9--horizontal-margin--V0kCf","icon-wrapper":"a10a3f92e9--icon-wrapper--jmyWE"};